import { move } from "@dnd-kit/helpers";

export default function musicOnHoldReducer(musicOnHold, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "addSound":
      return { ...musicOnHold, entries: [...musicOnHold.entries, action.entry] };
    case "removeSound":
      return { ...musicOnHold, entries: musicOnHold.entries.filter((entry) => entry.id !== action.entry.id) };
    case "moveSound": {
      const entries = move(musicOnHold.entries, action.event).map((entry, index) => ({
        ...entry,
        position: index + 1,
      }));

      return { ...musicOnHold, entries };
    }

    default:
      return { ...musicOnHold, [action.type]: action.value };
  }
}
